

<!-- header end -->

<!-- body -->
<!-- basecamp -->
<!-- <div class="dlab-bnr-inr overlay-primary" style="background-image:url(../assets/images/bg_brad.jpg);">
    <div class="overlay_fg">
        <div class="container">
            <div class="dlab-bnr-inr-entry">
                <h1 class="text-white">Features
                </h1>
                <div class="breadcrumb-row">
                    <ul class="list-inline">
                        <li><a routerLink="/">Home</a></li>/
                        <li>features</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- service us part  -->
<div class="deature_section_part">
    <div class="">
        <div class="feture_left_rg">
          <div class="row">
              <div class="col-sm-12">
                  <div class="feture_heading">
                      <h3> <span class="sub_secytry">GET CASH REWARDS FOR A WHOLE YEAR!
                      </span><br>Share the app with other businesses.</h3>
                      <p style="text-align: justify;">Referring the platform fosters a sense of community and collaboration among professionals and businesses, which can lead to shared success. Here's another good reason! You can refer to other business owners and professionals to earn Cash Rewards. The moment a business house or a professional on-boarded through your referral link, you are going to get the reward. Recieve 20% of the transacted amount by these referred businesses for one year.
                      </p>
                      <!-- <p style="text-align: justify;">Referring the LookzUp Business platform to other business houses or professionals in the beauty and fitness industry can be a win-win situation for all. It can help your peers improve businesses, strengthen industry connections, and potentially provide benefits to your own business.
                      </p> -->
                  </div>

                  <div class="send-invitation-container">
                    <div class="send_inv">
                    <h2>Send Invitations</h2>
                    <div class="via_thter">
                     <mat-chip-listbox #chipList aria-label="Invitation list">
                      <mat-chip class="activenm"  [ngClass]="{'activenm1': selectedValue == '1'}" (click)="changeChip('1')">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256.064 0h-.128C114.784 0 0 114.816 0 256c0 56 18.048 107.904 48.736 150.048l-31.904 95.104 98.4-31.456C155.712 496.512 204 512 256.064 512 397.216 512 512 397.152 512 256S397.216 0 256.064 0zm148.96 361.504c-6.176 17.44-30.688 31.904-50.24 36.128-13.376 2.848-30.848 5.12-89.664-19.264-75.232-31.168-123.68-107.616-127.456-112.576-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624 26.176-62.304c6.176-6.304 16.384-9.184 26.176-9.184 3.168 0 6.016.16 8.576.288 7.52.32 11.296.768 16.256 12.64 6.176 14.88 21.216 51.616 23.008 55.392 1.824 3.776 3.648 8.896 1.088 13.856-2.4 5.12-4.512 7.392-8.288 11.744-3.776 4.352-7.36 7.68-11.136 12.352-3.456 4.064-7.36 8.416-3.008 15.936 4.352 7.36 19.392 31.904 41.536 51.616 28.576 25.44 51.744 33.568 60.032 37.024 6.176 2.56 13.536 1.952 18.048-2.848 5.728-6.176 12.8-16.416 20-26.496 5.12-7.232 11.584-8.128 18.368-5.568 6.912 2.4 43.488 20.48 51.008 24.224 7.52 3.776 12.48 5.568 14.304 8.736 1.792 3.168 1.792 18.048-4.384 35.52z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>
                        Invite via WhatsApp
                      </mat-chip>
                        <mat-chip  [ngClass]="{'activenm1': selectedValue == '2'}" (click)="changeChip('2')">
                          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M298.789 313.693c-12.738 8.492-27.534 12.981-42.789 12.981-15.254 0-30.05-4.489-42.788-12.981L3.409 173.82A76.269 76.269 0 0 1 0 171.403V400.6c0 26.278 21.325 47.133 47.133 47.133h417.733c26.278 0 47.133-21.325 47.133-47.133V171.402a75.21 75.21 0 0 1-3.416 2.422z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="m20.05 148.858 209.803 139.874c7.942 5.295 17.044 7.942 26.146 7.942 9.103 0 18.206-2.648 26.148-7.942L491.95 148.858c12.555-8.365 20.05-22.365 20.05-37.475 0-25.981-21.137-47.117-47.117-47.117H47.117C21.137 64.267 0 85.403 0 111.408a44.912 44.912 0 0 0 20.05 37.45z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>
                          Invite via Email
                        </mat-chip>
                      </mat-chip-listbox>

                    </div>

                    <!-- whatsapp  -->
                    <div class="emkl">
                    
                      <mat-form-field appearance="outline" class="country-code col-12" *ngIf="selectedValue == '1'">
                        <mat-label>Country Code</mat-label>
                        <mat-select
                        [(ngModel)]="selectedCountryCode"
                        required
                        (selectionChange)="onCountrySelected($event)"
                      >
                        <mat-select-trigger>
                                      
                              {{ "(" + selectedCountryCode.dial_code + ")" }}
                        </mat-select-trigger>
                        
                        <mat-option>
                          <ngx-mat-select-search
                            noEntriesFoundLabel="no results found"
                            name="countrysearch"
                            placeholderLabel="Enter country name"
                            [formControl]="searchString"
                            (keyup)="onKey()"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let country of countryList" [value]="country">
                          {{ country.flag }} {{ country.name }}
                          {{ "(" + country.dial_code + ")" }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                 
                      <mat-form-field appearance="outline" class="custom-input" style="position: relative;" [ngClass]="{'col-12': selectedValue == '1'}">
                        
                        <mat-label *ngIf="selectedValue == '1'">Enter number.</mat-label>
                        <input matInput [(ngModel)]="whatsappNumbers" *ngIf="selectedValue == '1'" type="tel" maxlength="17" minlength="3" smNumericOnly>

                        <!-- have to restrict to 5 emails -->
                        <mat-label *ngIf="selectedValue == '2'">Enter email id. Use comma(,) for multiple emails.</mat-label>
                        <input matInput [(ngModel)]="emailAddresses" *ngIf="selectedValue == '2'">


                        <div class="send_hb">
                          <button mat-flat-button color="primary" class="custom-button" (click)="send()" [disabled]="checkdis()">Send</button>
                        </div>
                      </mat-form-field>
                  
                    </div>
                    </div>

                    <!--whatsapp  -->
                </div>
                    <!-- <div class="or-divider">
                      OR SHARE VIA
                    </div> -->
                    <div class="shk_flexc">
                        <div class="shreay_onl" (click)="copyText()">
                          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M11 6C12.6569 6 14 4.65685 14 3C14 1.34315 12.6569 0 11 0C9.34315 0 8 1.34315 8 3C8 3.22371 8.02449 3.44169 8.07092 3.65143L4.86861 5.65287C4.35599 5.24423 3.70652 5 3 5C1.34315 5 0 6.34315 0 8C0 9.65685 1.34315 11 3 11C3.70652 11 4.35599 10.7558 4.86861 10.3471L8.07092 12.3486C8.02449 12.5583 8 12.7763 8 13C8 14.6569 9.34315 16 11 16C12.6569 16 14 14.6569 14 13C14 11.3431 12.6569 10 11 10C10.2935 10 9.644 10.2442 9.13139 10.6529L5.92908 8.65143C5.97551 8.44169 6 8.22371 6 8C6 7.77629 5.97551 7.55831 5.92908 7.34857L9.13139 5.34713C9.644 5.75577 10.2935 6 11 6Z" fill="#ffc107"></path> </g></svg> Share link
                    </div>
                    <div class="shreay_onl" (click)="shareFacebook()">
                        <mat-icon>facebook</mat-icon> Facebook
                    </div>
                    <div class="shreay_onl" (click)="shareTwitter()">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 1227 1227" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M654.53 592.55 930.65 987.5H817.33L592.01 665.22v-.02l-33.08-47.31-263.21-376.5h113.32l212.41 303.85z" fill="#ffc107" opacity="1" data-original="#000000" class=""></path><path d="M1094.42 0H132.58C59.36 0 0 59.36 0 132.58v961.84C0 1167.64 59.36 1227 132.58 1227h961.84c73.22 0 132.58-59.36 132.58-132.58V132.58C1227 59.36 1167.64 0 1094.42 0zm-311.8 1040.52L554.61 708.68l-285.47 331.84h-73.78l326.49-379.5-326.49-475.17h249.02l215.91 314.23 270.32-314.23h73.78l-311.33 361.9h-.02l338.6 492.77z" fill="#ffc107" opacity="1" data-original="#000000" class=""></path></g></svg> Twitter
                    </div>
<!-- 
                    <div class="shreay_onl">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M301 256c0 24.852-20.148 45-45 45s-45-20.148-45-45 20.148-45 45-45 45 20.148 45 45zm0 0" fill="#ffc107" opacity="1" data-original="#000000" class=""></path><path d="M332 120H180c-33.086 0-60 26.914-60 60v152c0 33.086 26.914 60 60 60h152c33.086 0 60-26.914 60-60V180c0-33.086-26.914-60-60-60zm-76 211c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm86-146c-8.285 0-15-6.715-15-15s6.715-15 15-15 15 6.715 15 15-6.715 15-15 15zm0 0" fill="#ffc107" opacity="1" data-original="#000000" class=""></path><path d="M377 0H135C60.562 0 0 60.563 0 135v242c0 74.438 60.563 135 135 135h242c74.438 0 135-60.563 135-135V135C512 60.562 451.437 0 377 0zm45 332c0 49.625-40.375 90-90 90H180c-49.625 0-90-40.375-90-90V180c0-49.625 40.375-90 90-90h152c49.625 0 90 40.375 90 90zm0 0" fill="#ffc107" opacity="1" data-original="#000000" class=""></path></g></svg> instagram
                  </div> -->

                  <div class="shreay_onl" (click)="shareLinkedin()">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 176 176" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M152 0H24A24 24 0 0 0 0 24v128a24 24 0 0 0 24 24h128a24 24 0 0 0 24-24V24a24 24 0 0 0-24-24zM60 139.28a3.71 3.71 0 0 1-3.71 3.72H40.48a3.71 3.71 0 0 1-3.72-3.72V73a3.72 3.72 0 0 1 3.72-3.72h15.81A3.72 3.72 0 0 1 60 73zM48.38 63a15 15 0 1 1 15-15 15 15 0 0 1-15 15zm94.26 76.54a3.41 3.41 0 0 1-3.42 3.42h-17a3.41 3.41 0 0 1-3.42-3.42v-31.05c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86A3.42 3.42 0 0 1 90.3 143H73.88a3.41 3.41 0 0 1-3.41-3.42V72.71a3.41 3.41 0 0 1 3.41-3.42H90.3a3.42 3.42 0 0 1 3.42 3.42v5.78c3.88-5.83 9.63-10.31 21.9-10.31 27.18 0 27 25.38 27 39.32z" data-name="Layer 2" fill="#ffc107" opacity="1" data-original="#000000" class=""></path></g></svg> linkedin
                </div>

                </div>


                     <!-- new section added -->
                         <div class="">
                       <div class="new_heading_this">
                        <h3>SHARE MARKETPLACE APP WITH YOUR CUSTOMERS!</h3>
                        <p>This people's app can be your ultimate link where one can search for your business effortlessly. They can book for services, membership, sessions, register attendance and communicate directly... all in a few taps. </p>
                        <a  (click)="openLink()">Share Customer app</a>
                      </div>
                  </div>
                  <!-- new section end -->

                  </div>


             
              <!-- <div class="col-sm-4">
                  <div class="feture_img">
                      <img src=".././assets/images/refer-friend.png">
                  </div>
              </div> -->
              <!-- <div class="col-sm-6" style="margin-top: -46px">
                <button style="font-weight: normal; font-size: 15px; padding: 5px 25px;  color: #fff;  border-radius: 8px;"  mat-flat-button  color="accent"
                (click)="inviteFriends()"
              >
              Get your referral link
              </button>
              </div> -->


            
            </div>

          </div>

<!-- new  -->

  


      </div>

    </div>


